const actions = {
  async addProductCategories(_context, payload) {
    try {
      const response = await this.$api.call(
        "partner.addProductCategories",
        payload,
      );

      return response;
    } catch (error) {
      throw error;
    }
  },

  async editProductCategories(_context, payload) {
    try {
      const response = await this.$api.call(
        "partner.editProductCategories",
        payload,
      );

      return response;
    } catch (error) {
      throw error;
    }
  },

  async deleteProductCategories(_context, payload) {
    try {
      const response = await this.$api.call(
        "partner.deleteProductCategories",
        payload,
      );

      return response;
    } catch (error) {
      throw error;
    }
  },

  async setDataEditPartner(context, payload) {
    try {
      const response = await this.$api.call("partner.getPartnerById", payload);

      context.commit("mutationSetDataEditPartner", response.data);

      return response;
    } catch (error) {
      context.commit("mutationSetDataEditPartner", {});
      throw error;
    }
  },

  async setDataEditPartnerProductCategoriesById(context, payload) {
    try {
      const response = await this.$api.call(
        "partner.getPartnerProductCategoriesById",
        payload,
      );

      context.commit(
        "mutationSetDataEditPartnerProductCategoriesById",
        response.data,
      );

      return response;
    } catch (error) {
      context.commit("mutationSetDataEditPartnerProductCategoriesById", {});
      throw error;
    }
  },

  async listProductCategoriesByOrganization(context, payload) {
    try {
      const response = await this.$api.call(
        "partner.listProductCategoriesByOrganization",
        payload,
      );

      context.commit(
        "mutationListProductCategoriesByOrganization",
        response.data,
      );

      return response;
    } catch (error) {
      context.commit("mutationListProductCategoriesByOrganization", {});
      throw error;
    }
  },

  async getPartnerProducts(context, payload) {
    try {
      const response = await this.$api.call("partner.products", payload);
      return response;
    } catch (error) {
      throw error;
    }
  },

  async getPartnerProductsV2(context, payload) {
    try {
      const response = await this.$api.call("partner.listProductsV2", payload);
      return response;
    } catch (error) {
      throw error;
    }
  },

  async updatePartnerProductStatusV2(context, payload) {
    const response = await this.$api.call("partner.updateProductV2", payload);
    return response;
  },

  async deletePartnerProductV2(context, payload) {
    const response = await this.$api.call("partner.deleteProductV2", payload);
    return response;
  },

  async getListProductsByInsuranceIdV2(context, payload) {
    const response = await this.$api.call(
      "partner.getListProductsByInsuranceIdV2",
      payload,
    );
    return response;
  },

  async getListProductsByInsuranceId(context, payload) {
    try {
      const response = await this.$api.call(
        "partner.getListProductsByInsuranceId",
        payload,
      );

      return response;
    } catch (error) {
      throw error;
    }
  },

  async addPartnerProductV2(context, payload) {
    const response = await this.$api.call(
      "partner.addPartnerProductV2",
      payload,
    );
    return response;
  },

  async addPartnerProduct(context, payload) {
    try {
      const response = await this.$api.call(
        "partner.addPartnerProduct",
        payload,
      );

      return response;
    } catch (error) {
      throw error;
    }
  },

  async updatePartnerProduct(context, payload) {
    try {
      const response = await this.$api.call(
        "partner.updatePartnerProduct",
        payload,
      );

      return response;
    } catch (error) {
      throw error;
    }
  },

  async getPartnerProductV2(context, payload) {
    const response = await this.$api.call(
      "partner.getPartnerProductV2",
      payload,
    );
    return response;
  },

  async getPartnerProduct(context, payload) {
    try {
      const response = await this.$api.call(
        "partner.getPartnerProduct",
        payload,
      );

      return response;
    } catch (error) {
      throw error;
    }
  },

  async deletePartnerProduct(context, payload) {
    try {
      const response = await this.$api.call(
        "partner.deletePartnerProduct",
        payload,
      );

      return response;
    } catch (error) {
      throw error;
    }
  },

  async updatePartnerProductStatus(context, payload) {
    try {
      const response = await this.$api.call(
        "partner.updatePartnerProductStatus",
        payload,
      );

      return response;
    } catch (error) {
      throw error;
    }
  },

  async getValidPartnerById(context, payload) {
    try {
      const response = await this.$api.call("organization.list", {
        query: {
          type: "PARTNER",
          code: payload.params.organizationId,
        },
      });

      if (response?.data?.length === 0) {
        throw new Error(
          `organization with id: ${payload.params.organizationId}, not found!`,
        );
      }
      const [selectedData] = response.data;
      context.commit("mutationSetPartnerDetail", selectedData);
      context.commit("organization/mutationOrganization", selectedData, {
        root: true,
      });

      return response;
    } catch (error) {
      context.commit("mutationSetPartnerDetail", {});
      context.commit(
        "organization/mutationOrganization",
        {},
        {
          root: true,
        },
      );
      throw error;
    }
  },
};

export default actions;
